<div class="shimmer-loader">
    <div class="shimmer {{radius}} {{colorClass}}" ></div>
</div>